import { useContext } from "react";
import { serverInfo } from "../../App";
import "./LeftCardVideos.css";

const LeftCardVideos = (props) => {

  const { videoCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="container left-col-box py-4">
        <h6 className="profile-font-color">{props.title}</h6>
        <div className="row">
          {props?.videos?.map(
            (data, index) =>
                <>
                  {data.type === "learningSession" &&
                    data?.learning_session?.video != null ? (
                    <div className="col-4">
                      <video width="100%" className="heightVideo" controls>
                        <source
                          src={videoCdnUrl + data?.learning_session?.video}
                          type="video/mp4"
                        />
                      </video>{" "}
                    </div>
                  ) : data.type === "audition" &&
                    data?.audition?.video != null ? (
                    <div className="col-4">
                      <video width="100%" className="heightVideo" controls>
                        <source
                          src={videoCdnUrl + data?.audition?.video}
                          type="video/mp4"
                        />
                      </video>{" "}
                    </div>
                  ) : data.type === "meetup" && data?.meetup?.video != null ? (
                    <div className="col-4">

                      <video className="heightVideo" width="150" controls>
                        <source
                          src={videoCdnUrl + data?.meetup?.video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : data.type === "fangroup" && data?.fangroup?.video != null ? (
                    <div className="col-4">

                      <video className="heightVideo" width="150" controls>
                        <source
                          src={videoCdnUrl + data?.fangroup?.video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : data?.type === "greeting" &&
                    data?.greeting_registration?.video != null ? (
                    <div className="col-4">
                      <video className="heightVideo" width="150" controls>
                        <source
                          src={videoCdnUrl + data?.greeting_registration?.video}
                          type="video/mp4"
                          controls
                        />
                      </video>
                    </div>
                  ) : data.type === "liveChat" &&
                    data?.livechat?.video != null ? (
                    <div className="col-4">

                      <video width="150" className="heightVideo" controls>
                        <source
                          src={videoCdnUrl + data?.livechat?.video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : data.type === "generalpost" &&
                    data?.generalpost?.video != null ? (
                    <div className="col-4">

                      <video width="150" className="heightVideo" controls>
                        <source
                          src={videoCdnUrl + data?.generalpost?.video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : null}
                </>
          )}
        </div>

        <div className="see-all-text  ">
          <a href="/" className="text-decoration-none profile-font-color">
            See all
          </a>
        </div>
      </div>
    </>
  );
};

export default LeftCardVideos;
